import { ajax } from '../http.js'

export default {

    /**
     * 添加志愿者方法
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    addVolunteer(searchParams, headers) {
        return ajax('frontapi/volunteer/main/addVolunteer', 'POST', searchParams, headers);
    },
    /**
     * 获取志愿者章程
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getVolunteerRule(searchParams) {
        return ajax('frontapi/volunteer/regulations/detail', 'GET', searchParams);
    },

    /**
     * 获取志愿者活动列表
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getVolunteerActivityList(searchParams) {
        return ajax('frontapi/volunteer/activity/list', 'GET', searchParams);
    },

    /**
     * 获取志愿者活动详情
     * @param searchParams 表名编码
     * @returns {Promise}
     */
    getVolunteerActivityDetail(url) {
        return ajax(url, 'GET', null);
    },


}